import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0db581a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "i-alarm" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "i-alarm-item__title" }
const _hoisted_4 = { class: "i-alarm-title" }
const _hoisted_5 = { class: "van-ellipsis" }
const _hoisted_6 = { class: "i-alarm-content" }
const _hoisted_7 = {
  key: 0,
  class: "i-alarm-content__item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警设备： ", -1))
const _hoisted_9 = { class: "orange i-alarm-content__right" }
const _hoisted_10 = { class: "i-alarm-content__item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警内容： ", -1))
const _hoisted_12 = { class: "i-alarm-content__right" }
const _hoisted_13 = {
  key: 1,
  class: "i-alarm-content__item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警参数： ", -1))
const _hoisted_15 = { class: "i-alarm-content__right" }
const _hoisted_16 = {
  key: 2,
  class: "i-alarm-content__item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警位置： ", -1))
const _hoisted_18 = { class: "orange i-alarm-content__right" }
const _hoisted_19 = { class: "i-alarm-bottom" }
const _hoisted_20 = { class: "i-alarm-date" }
const _hoisted_21 = {
  key: 0,
  class: "i-alarm-overtime"
}
const _hoisted_22 = {
  key: 1,
  class: "i-alarm-relieve"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "i-alarm-item__title" }
const _hoisted_25 = { class: "i-alarm-title" }
const _hoisted_26 = { class: "van-ellipsis" }
const _hoisted_27 = { class: "i-alarm-content" }
const _hoisted_28 = {
  key: 0,
  class: "i-alarm-content__item"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警设备： ", -1))
const _hoisted_30 = { class: "orange i-alarm-content__right" }
const _hoisted_31 = { class: "i-alarm-content__item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警内容： ", -1))
const _hoisted_33 = { class: "i-alarm-content__right" }
const _hoisted_34 = {
  key: 1,
  class: "i-alarm-content__item"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警参数： ", -1))
const _hoisted_36 = { class: "i-alarm-content__right" }
const _hoisted_37 = {
  key: 2,
  class: "i-alarm-content__item"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-alarm-content__left" }, " 报警位置： ", -1))
const _hoisted_39 = { class: "orange i-alarm-content__right" }
const _hoisted_40 = { class: "i-alarm-bottom" }
const _hoisted_41 = { class: "i-alarm-date" }
const _hoisted_42 = {
  key: 0,
  class: "i-alarm-overtime"
}
const _hoisted_43 = {
  key: 1,
  class: "i-alarm-relieve"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: $setup.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      sticky: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "进行中" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.inProgress, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "i-alarm-item",
                key: item.id,
                onClick: ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.ALARM_DETAIL,
              query: {
                id: item.id
              }
            })
          )
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "i-alarm-level",
                    style: _normalizeStyle({
                backgroundColor: $setup.levelColor[item.alarm_level]
              })
                  }, _toDisplayString(item.alarm_level_name), 5),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.alarm_content), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "i-alarm-status",
                    style: _normalizeStyle({
                backgroundColor: $setup.statusColor[item.alarm_state]
              })
                  }, _toDisplayString(item.alarm_state_name), 5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (item.device_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.device_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.alarm_content), 1)
                  ]),
                  (item.iot_params_show)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.iot_params_show), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.true_place)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.true_place), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.alarm_time_name), 1),
                  (item.is_overtime_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.is_overtime_name), 1))
                    : _createCommentVNode("", true),
                  (item.relieve_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.relieve_name), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "已完成" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.doneList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "i-alarm-item",
                key: item.id,
                onClick: ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.ALARM_DETAIL,
              query: {
                id: item.id
              }
            })
          )
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: "i-alarm-level",
                    style: _normalizeStyle({
                backgroundColor: $setup.levelColor[item.alarm_level]
              })
                  }, _toDisplayString(item.alarm_level_name), 5),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.alarm_content), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "i-alarm-status",
                    style: _normalizeStyle({
                backgroundColor: $setup.statusColor[item.alarm_state]
              })
                  }, _toDisplayString(item.alarm_state_name), 5)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (item.device_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.device_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(item.alarm_content), 1)
                  ]),
                  (item.iot_params_show)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, _toDisplayString(item.iot_params_show), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.true_place)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, _toDisplayString(item.true_place), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, _toDisplayString(item.alarm_time_name), 1),
                  (item.is_overtime_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(item.is_overtime_name), 1))
                    : _createCommentVNode("", true),
                  (item.relieve_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(item.relieve_name), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_23))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}